// ProtectedRoute.js
import React from "react";
import { Navigate } from "react-router-dom";

const ProtectedRoute = ({ children, requiredRole }) => {
  const token = localStorage.getItem("token");
  const user = JSON.parse(localStorage.getItem("user"));

  if (!token || !user) {
    // If not authenticated, redirect to login
    return <Navigate to="/" />;
  }

  if (requiredRole && user.role !== requiredRole) {
    // If user does not have the required role, redirect to login or 404
    return <Navigate to="/" />;
  }

  // Render children if authenticated and authorized
  return children;
};

export default ProtectedRoute;
